/** The five pillars that Ground's free Foundations protocol introduces. */

export type Pillar = 'somatic' | 'movement' | 'digital' | 'nature' | 'rest';

export interface PillarMeta {
  label: string;
  emoji: string;
  blurb: string;
  /** Tailwind gradient classes for card accents. */
  hue: string;
  /** Solid text accent colour. */
  accent: string;
}

export const PILLARS: Record<Pillar, PillarMeta> = {
  somatic: {
    label: 'Somatic',
    emoji: '🧘',
    blurb: 'Tune into the body without trying to fix it.',
    hue: 'from-violet-500/15 to-fuchsia-500/5',
    accent: 'text-violet-400',
  },
  movement: {
    label: 'Movement',
    emoji: '🕺',
    blurb: 'Move to discharge, not to perform.',
    hue: 'from-amber-500/15 to-orange-500/5',
    accent: 'text-amber-400',
  },
  digital: {
    label: 'Digital',
    emoji: '📱',
    blurb: 'Take one small piece of attention back.',
    hue: 'from-sky-500/15 to-cyan-500/5',
    accent: 'text-sky-400',
  },
  nature: {
    label: 'Nature',
    emoji: '🌿',
    blurb: 'Let the outdoors do the work. No gear needed.',
    hue: 'from-emerald-500/15 to-lime-500/5',
    accent: 'text-emerald-400',
  },
  rest: {
    label: 'Rest',
    emoji: '🌙',
    blurb: 'Deliberate rest — not sleep, not laziness.',
    hue: 'from-indigo-500/15 to-blue-500/5',
    accent: 'text-indigo-400',
  },
};

export const PILLAR_ORDER: Pillar[] = ['somatic', 'movement', 'digital', 'nature', 'rest'];
